// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2p-1";
export var rateTableServiceLevelDropdown = "_2p-3";
export var rateTableTypeDropdown = "_2p-0";
export var rateTableValueModeDropdown = "_2p-2";